import styled from "styled-components"

export const MealFoodContent = styled.div`
  height: calc(100% - var(--header-height) - var(--app-cta-height));
  padding: 12px var(--app-horizontal-padding) 8px var(--app-horizontal-padding);
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
`

export const FormItemLabel = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 160%;
  margin-bottom: 12px;

  span {
    font-weight: 400;
  }
`

export const NutritionGroupInputsWrapper = styled.div`
  border-radius: 8px;
  border: 1px solid var(--Schemes-Outline-Variant, rgba(0, 38, 58, 0.14));
  background: var(--White, #fff);
`
